export default __webpack_public_path__ + "static/media/small.94766826.jpg";